import React from 'react';

import { Field } from 'react-final-form';

const FormSelect = ({ label, required, placeholder, name, validate, options }) => {
  return (
    <div className="form-field">
      <Field placeholder={placeholder} name={name} validate={validate}>
        {({ input, meta }) => {
          return (
            <div className={`form-group ${meta.error && meta.touched ? 'error' : ''}`}>
              <label htmlFor={`${name}`}>
                {label}
                <span className="required">{required ? '*' : ''}</span>
              </label>
              <select {...input}>
                <option value="">{placeholder}</option>
                {options.map(({ title, value }, index) => (
                  <option key={`${name}.${title}.${value}.${index}`} value={value}>
                    {title}
                  </option>
                ))}
              </select>

              {meta.error && meta.touched && <p className="error-text">{meta.error}</p>}
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default FormSelect;
